var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"flex justify-center text-white py-4 lg:px-36",attrs:{"id":"navbar"}},[_c('div',{staticClass:"logo flex justify-center text-2xl flex items-center lg:mr-8 px-4 lg:px-0"},[_c('Logo')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }